import React from "react";
import "./App.css";
import { withAuth0, WithAuth0Props } from "@auth0/auth0-react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ProtectedRoute } from "auth/ProtectedRoute";
import NotFoundPage from "pages/core/notFound/NotFoundPage";
import auth from "utilities/AuthUtility";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ActiveLoansListPage from "pages/loan/loansList/active/ActiveLoansListPage";
import ClosedLoansListPage from "pages/loan/loansList/closed/ClosedLoansListPage";
import LoanDetailsPage from "pages/loan/loanDetails/LoanDetailsPage";
import ErrorPage from "pages/core/error/ErrorPage";
import LoadingSpinner from "shared/components/spinner/LoadingSpinner";
import { IconPack, library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import Header from "shared/components/header/Header";
import CustomerLandingPage from "pages/customerAccount/landingPage/CustomerLandingPage";
import CreateAccountPage from "pages/customerAccount/createAccount/CreateAccountPage";
import CreateLoanPage from "pages/loan/createLoan/CreateLoanPage";
import SubmitLoanPage from "pages/customerAccount/submitLoan/SubmitLoanPage";
import ThankYouPage from "pages/customerAccount/thankYouPage/ThankYouPage";
import LandingHeader from "shared/components/landingHeader/LandingHeader";
import WhiteLabelLoanPage from "pages/loan/whiteLabel/WhiteLabelLoanPage";
import AuthErrorPage from "pages/core/authError/AuthErrorPage";

interface RouteState {
  //subdomain: Subdomain;
}

class App extends React.Component<WithAuth0Props, RouteState> {
  constructor(props: WithAuth0Props) {
    super(props);

    // This isn't ideal, but due to react-auth0 SDK the "recommended" way
    // to expose auth0 methods externally from components is via below.
    // https://github.com/auth0/auth0-react/issues/67#issuecomment-661874041
    auth.setAccessTokenSilently(this.props.auth0.getIdTokenClaims);
    auth.setLogout(this.props.auth0.logout);

    library.add(fas as IconPack);
  }

  componentDidMount(): void {

  }

  componentDidUpdate(prevProps: Readonly<WithAuth0Props>, prevState: Readonly<RouteState>, snapshot?: any): void {

  }

  render() {
    const { error, isAuthenticated, isLoading } = this.props.auth0;

    return (
      <div className="container-fluid container-fill">
        {isLoading ?
          <LoadingSpinner
            variant={'dark'}
            animation={'border'}
          />
          :
          <>
            {error ?
              <AuthErrorPage error={error} />
              :
              <div>
                <ToastContainer />
                
                {isAuthenticated &&
                  <>
                    <Header />
                    <div className="Content parent-switch-selector">
                      {/* A <Switch> looks through its children <Route>s and
                         renders the first one that matches the current URL. */}
                      <Switch >
                        <ProtectedRoute path="/active" component={ActiveLoansListPage} />
                        <ProtectedRoute path="/closed" component={ClosedLoansListPage} />
                        <ProtectedRoute path="/dealer/:sqId/financing" component={WhiteLabelLoanPage} />
                        <ProtectedRoute path="/loan/create" component={CreateLoanPage} />
                        <ProtectedRoute path="/loan/:id" component={LoanDetailsPage} />

                        {/* <Route path="/callback">
                  <LoadingSpinner
                    variant={'dark'}
                    animation={'border'}
                  />
                </Route> */}

                        <Route exact path={["/", "/callback", ""]}>
                          <Redirect to="/active" />
                        </Route>

                        <Route component={NotFoundPage} />
                      </Switch>
                    </div>
                  </>
                }

                {!isAuthenticated &&
                  <>
                    <LandingHeader />
                    <div className="Content parent-switch-selector">
                      <Switch>
                        <Route path="/create-account" component={CreateAccountPage} />
                        <Route path="/dealer/:sqId/financing" component={WhiteLabelLoanPage} />
                        <Route path="/loan/submit" component={SubmitLoanPage} />
                        <Route path="/thank-you/:loanId" component={ThankYouPage} />
                        <Route component={CustomerLandingPage} />
                      </Switch>
                    </div>
                  </>
                }
              </div>
            }
          </>
        }
      </div>
    );
  }
}

export default withAuth0(App);
